import gql from 'graphql-tag';

import STATUS_DOCKETS_FRAGMENT from './STATUS_DOCKETS_FRAGMENT';

const REMOVE_MACHINE_FROM_SERVICE_RUN = gql`
	mutation removeMachineFromServiceRun (
		$machineId: ID!,
		$serviceRunId: ID!,
	) {
		removeMachineFromServiceRun (
			machineId: $machineId,	
			serviceRunId: $serviceRunId,
		) {
			id
			cashReconciliationStatus
			serviceDockets {
				...statusDockets
			}
		}
	}
	${STATUS_DOCKETS_FRAGMENT}
`;

export default REMOVE_MACHINE_FROM_SERVICE_RUN;
